var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selected-items-block-reset",on:{"click":function($event){return _vm.$emit('reset')}}},[_c('div',{staticClass:"selected-items-block-reset__cross"},[_c('MIcon',{attrs:{"icon":_vm.iconCross}})],1),_vm._v(" "),_c('div',{staticClass:"selected-items-block-reset__text"},[_vm._v("\n    "+_vm._s(_vm._getTr('reset_all'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }